import { fillOffset } from './basler-components.es768.js';

function defaultOffset(arr) {
    const offset = [0];
    fillOffset(offset, arr.length - 1);
    return offset;
}

export { defaultOffset };
